<template>
  <div>
      <div class="title">
        <span>位置：</span>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>财务管理</el-breadcrumb-item>
          <el-breadcrumb-item>报表中心</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="tab">
          <div v-for="(item,index) in tab" :key="index" :class="index==active?'switDiv':''" @click="tabs(index)">
              <span>{{ item.title }}</span>
              <div>
                <span>{{ item.txt }}</span>
                <img :src="item.img" alt="">
              </div>
          </div>
      </div>
      <div  class="center">
          <div v-if="active==0">
            <div class="orders">
              <div>
                <span>手机号：</span>
                <el-input v-model="dataOrder.Mobile" placeholder="请输入手机号"></el-input>
              </div>
              <div>
                <span>订单：</span>
                <el-input v-model="dataOrder.OrderNumber" placeholder="请输入订单号"></el-input>
              </div>
              <div>
                <span>日期：</span>
                <div>
                  <el-date-picker
                    @change="changeData(true)"
                    v-model="dataOrder.start_time"
                    value-format="yyyy-MM-dd 00:00:00"
                    type="date"
                    placeholder="选择日期">
                  </el-date-picker>
                  <span style="margin:0 1rem;">至</span>
                  <el-date-picker
                    @change="changeData(false)"
                    v-model="dataOrder.end_time"
                    value-format="yyyy-MM-dd 23:59:59"
                    type="date"
                    placeholder="选择日期">
                  </el-date-picker>
                </div>
              </div>
            </div>
            <div class="select_bot">
              <div class="select">
                <span>分销商：</span>
                <el-select v-model="dataOrder.DistributorID" clearable placeholder="请选择分销商">
                  <el-option
                    v-for="item in orderOption"
                    :key="item.DistrbutorID"
                    :label="item.Name"
                    :value="item.DistrbutorID">
                  </el-option>
                </el-select>
              </div>
              <div class="select"  v-if="GetChannelFlow">
                <span>渠道：</span>
                <el-select  v-model="dataOrder.channelCode" placeholder="渠道" clearable>
                  <el-option
                    v-for="item in opstatusan"
                    :key="item.channelCode"
                    :label="item.channelName"
                    :value="item.channelCode"
                  ></el-option>
                </el-select>
              </div>
              
            </div>
          </div>
          <div v-if="active==1">
            <div class="orders">
              <div>
                <span>产品：</span>
                <el-select v-model="data2.productid" clearable  placeholder="请选择产品">
                  <el-option
                    v-for="item in proOption"
                    :key="item.ProductID"
                    :label="item.ProductName"
                    :value="item.ProductID">
                  </el-option>
                </el-select>
              </div>
              <div>
                <span>日期：</span>
                <div>
                  <el-date-picker
                    v-model="data2.start_date"
                    value-format="yyyy-MM-dd 00:00:00"
                    type="date"
                    @change="changeData1(true)"
                    placeholder="选择开始日期">
                  </el-date-picker>
                  <span style="margin:0 1rem;">至</span>
                  <el-date-picker
                    v-model="data2.end_date"
                    value-format="yyyy-MM-dd 23:59:59"
                    @change="changeData1(false)"
                    type="date"
                    placeholder="选择结束日期">
                  </el-date-picker>
                </div>
              </div>
            </div>
            <div class="select_bot">
              <div class="select">
                <span>分销商：</span>
                <el-select v-model="data2.DistributorID" clearable placeholder="请选择分销商">
                  <el-option
                    v-for="item in disoptions"
                    :key="item.DistrbutorID"
                    :label="item.Name"
                    :value="item.DistrbutorID">
                  </el-option>
                </el-select>
              </div>
              <div class="select" v-if="!GetChannelFlow"  style="margin-left:2rem;">
                <span>展示内容：</span>
                <el-select v-model="types" clearable>
                  <el-option
                    v-for="item in doption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">  
                  </el-option>
                </el-select>
              </div>
              <div class="select" v-if="GetChannelFlow" style="margin-left:2rem;">
                <span>展示内容：</span>
                <el-select v-model="types" clearable>
                  <el-option
                    v-for="item in doption2"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">  
                  </el-option>
                </el-select>
              </div>
              <div class="select"  style="margin-left:4rem;">
                <span>微信交易单号：</span>
                <el-select v-model="data2.is_wx" >
                  <el-option
                    v-for="item in iswxO"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">  
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div v-if="active==2">
            <div class="orders">
              <div  >
                <span>订单号：</span>
                <el-input v-model="data3.order_id" placeholder="请输入订单号"></el-input>
              </div>
              <div>
                <span>日期：</span>
                <div>
                  <el-date-picker
                    v-model="data3.start_time"
                    value-format="yyyy-MM-dd 00:00:00"
                    type="date"
                    @change="changeData2(true)"
                    placeholder="选择开始日期">
                  </el-date-picker>
                  <span style="margin:0 1rem;">至</span>
                  <el-date-picker
                    v-model="data3.end_time"
                    value-format="yyyy-MM-dd 23:59:59"
                    @change="changeData2(false)"
                    type="date"
                    placeholder="选择结束日期">
                  </el-date-picker>
                </div>
              </div>
            </div>
            <div class="select_bot">
          
              <div class="select" >
                <span>核销码：</span>
                <el-input v-model="data3.origin_code" placeholder="请输入核销码"></el-input>
              </div>
            </div>
          </div>
          <!--  -->
          <div class="ative_btns">
            <div v-if="active==0">
                <div @click="exportOrder" :class="activeCss=='01523'?'Selected':''">订单导出</div>
                <!-- <div @click="Verification" :class="activeCss=='2'?'Selected':''">核销订单</div> -->
                <!-- <div>用户信息报表导出</div> -->
                <!-- <div @click="exportMing" :class="activeCss=='3'?'Selected':''">订单核销明细</div> -->
            </div>
            <div v-if="active==1">
                <div @click="saleTwo('0')"  :class="activeCss=='12'?'Selected':''">销售统计导出</div>
                <!-- <div @click="salefour" :class="activeCss=='166'?'Selected':''">销售详情</div> -->
                <div @click="ptionTwo('0')"  :class="activeCss=='11'?'Selected':''">核销统计导出</div>
                <!-- <div @click="ptionTwo('1')"  :class="activeCss=='112'?'Selected':''">核销统计导出（产品）</div> -->
                <div @click="ptionTwoDetail" :class="activeCss=='155'?'Selected':''">核销详情</div>
                <div @click="ticketTwo('0')"   :class="activeCss=='10'?'Selected':''">退票统计导出</div>
                <!-- <div @click="ticketTwo('1')"  :class="activeCss=='122'?'Selected':''">退票统计导出（产品）</div> -->
                <div @click="ticketTwoDetail" :class="activeCss=='144'?'Selected':''">退票详情</div>
            </div>
            <div v-if="active==2">
               <div :class="activeCss=='255'?'Selected':''" @click="douyinReport">核销导出</div>
                <!-- <div @click="sale('0')" :class="activeCss=='20'?'Selected':''">销售统计导出</div> -->
                <!-- <div @click="saleThree" :class="activeCss=='233'?'Selected':''">销售详情</div> -->
                <!-- <div @click="sale('1')" :class="activeCss=='202'?'Selected':''">销售统计导出（产品）</div> -->
                <!-- <div @click="ption('0')" :class="activeCss=='21'?'Selected':''">核销统计导出</div> -->
                <!-- <div @click="ption('1')" :class="activeCss=='212'?'Selected':''">核销统计导出（产品）</div> -->
                <!-- <div @click="ptionDeta" :class="activeCss=='255'?'Selected':''">核销记录详情</div> -->
                <!-- <div @click="ticket('0')" :class="activeCss=='22'?'Selected':''">退票统计导出</div> -->
                <!-- <div @click="ticket('1')" :class="activeCss=='222'?'Selected':''">退票记录（产品）</div> -->
                <!-- <div @click="ticketDeta" :class="activeCss=='266'?'Selected':''">退票记录详情</div> -->
            </div>
          </div>
      </div>
  </div>
</template>
<script>
import {ScenicPostExport,TicketConsumeExport,GetScenicList,getScenicListDistrbutor,
  ProductIDSalesStatisticsExport,exportSalesStatistics, //  销售导出
  TicketConsumeTJExport,ProductTicketConsumeTJExport, // 核销(核销)导出
  RefundDateExport,ProductRefundExport,
  RefundExport,
  exportDistributorSalesStatistics,
  ScenicDisSellOneExport,
  ScenicDisTicketTJExport,DisProductVerifiExport,
  DistributorIDRefundDateExport,DisProductRefundExport,
  RefundTJXQExport,ScenicDisTicketTJXQExport,
  VerificationSheetExport,VerificationSheetDetailExport,
  DirectSellingTJXqExport,
  GetScenicDisSellOneExport,getScenicOrderList,
  exportDouyinCodeVerifyRecord,
  distributorProductTJExport, channelCodeProductTJExport,
  GetChannel
 } from '@/request/scenic.js'
import {dataConversionUtil} from "@/request/exportExcel.js";
  export default{
    data(){
      return{
        tab:[
          {
            title:'订单管理',
            txt:'数据导出',
            img:require('../../../images/report/order.png')
          },
          {
            title:'分销统计',
            txt:'数据导出',
            img:require('../../../images/report/fenxiao.png')
          },
          {
            title:'抖音统计',
            txt:'数据导出',
            img:require('../../../images/report/zhixiao.png')
          }
        ],
        active:'0',
        value1:'',
        options: [{
          value: '选项1',
          label: '黄金糕'
        }, {
          value: '选项2',
          label: '双皮奶'
        }, {
          value: '选项3',
          label: '蚵仔煎'
        }, {
          value: '选项4',
          label: '龙须面'
        }, {
          value: '选项5',
          label: '北京烤鸭'
        }],
        iswxO:[
          {
            value: '1',
            label: '否'
          },
          {
            value: '2',
            label: '是'
          }
        ],
        data1:{
          input1:'',
          date1:'',
          date2:'',
          dis:'',
          inspect:''
        },
        proOption:[],
        disoptions:[
          {
            Name:'景区直销',
            DistrbutorID:'a'
          }
        ],
        orderOption:[
          {
            Name:'景区直销',
            DistrbutorID:'a'
          }
        ],
        data3:{
          token:window.sessionStorage.getItem('Token'),
          start_time:'',
          end_time:'',
          origin_code:'',
          order_id:''
        },
        data2:{
          token:window.sessionStorage.getItem('Token'),
          start_date:'',
          end_date:'',
          DistributorID:'',
          ProductID:'',
          is_wx:'1'
        },
        dataOrder:{
          token:window.sessionStorage.getItem('Token'),
          Mobile:'',
          OrderNumber:'',
          start_time:'',
          end_time:'',
          status:'',
          DistributorID:'',
          channelCode:''
        },
        activeCss:'',
        doption:[
            {
              value:'1',
              label:'每日'
            },
            {
              value:'2',
              label:'产品'
            }
        ],
        doption2:[
            {
              value:'1',
              label:'每日'
            },
            {
              value:'2',
              label:'产品'
            },
            {
              value:'3',
              label:'分销商产品'
            },
            {
              value:'4',
              label:'渠道商产品'
            }
        ],
        types:'',
        timer:null,
        GetChannelFlow:false,
        opstatusan:[
        ],
        timesIng:''
      }
    },
    created(){
      if(window.sessionStorage.getItem('ScenicId')=='131'){
        this.GetChannelFlow = true
      }
      let data = {
        token:window.sessionStorage.getItem('Token'),
        page:1,
        page_size:9999
      }
      GetChannel(data).then(res=>{
        if(res.data.status=='ok'){
          this.opstatusan=res.data.result
        }
      })
      // 产品
      GetScenicList(data).then(res=>{
        if(res.data.status=='ok'){
          this.proOption = res.data.result.data
        }
      })
      // 分销商
      getScenicListDistrbutor(data).then(res=>{
        if(res.data.status=='ok'){
          this.disoptions =  [...this.disoptions,...res.data.result.data] 
          this.orderOption = [...this.orderOption,...res.data.result.data]
        }
      })
      if(this.$route.params.id>=0){
        this.types = this.$route.params.data.type
        this.active = this.$route.params.id
        this.activeCss = this.$route.params.id + '' + this.$route.params.index + '' 
        console.log(this.$route.params)
        if(this.activeCss=='01523'){
          console.log(this.$route)
          this.dataOrder={
            token:window.sessionStorage.getItem('Token'),
            Mobile:this.$route.params.data.Mobile,
            OrderNumber:this.$route.params.data.OrderNumber,
            start_time:this.$route.params.data.start_time,
            end_time:this.$route.params.data.end_time,
            status:this.$route.params.data.status,
            DistributorID:this.$route.params.data.DistributorID
          }
        }
        if(this.active=='2'){
          if(this.activeCss=='266'){
            this.data3.starttime = this.$route.params.data.start_date + ' 00:00:00'
            this.data3.endtime = this.$route.params.data.end_date + ' 23:59:59'
            this.data3.ProductID = this.$route.params.data.productid 
            return false
          }
          if(this.activeCss=='255'){
            this.data3.starttime = this.$route.params.data.starttime + ' 00:00:00'
            this.data3.endtime =this.$route.params.data.endtime + ' 23:59:59'
            this.data3.ProductID = this.$route.params.data.productid
            return false
          }
          if(this.activeCss=='233'){
            this.data3.starttime = this.$route.params.data.starttime + ' 00:00:00'
            this.data3.endtime =this.$route.params.data.endtime + ' 23:59:59' 
            this.data3.ProductID = this.$route.params.data.ProductID
            return false
          }
            this.data3.starttime = this.$route.params.data.Times[0] + ' 00:00:00'
            this.data3.endtime = this.$route.params.data.Times[1] + ' 23:59:59'
            this.data3.ProductID = this.$route.params.data.productid 
            this.data3.distributorid = this.$route.params.data.disid
        }else if(this.active=='1'){
            if(this.activeCss=='144'){
              this.data2.start_date = this.$route.params.data.start_date + ' 00:00:00'
              this.data2.end_date = this.$route.params.data.end_date + ' 23:59:59'
              this.data2.DistributorID = this.$route.params.data.distributorid
              this.data2.ProductID = this.$route.params.data.productid
              return false
            }
            if( this.activeCss=='155'){
              this.data2.start_date = this.$route.params.data.start_date + ' 00:00:00'
              this.data2.end_date = this.$route.params.data.end_date + ' 23:59:59'
              this.data2.DistributorID = this.$route.params.data.distributorid
              this.data2.ProductID = this.$route.params.data.productid
              return false
            }
            if(this.activeCss=='166'){
              this.data2.start_date = this.$route.params.data.start_date + ' 00:00:00'
              this.data2.end_date = this.$route.params.data.end_date + ' 23:59:59'
              this.data2.DistributorID = this.$route.params.data.distributorid
              this.data2.ProductID = this.$route.params.data.productid
              return false
            }
            this.data2.start_date = this.$route.params.data.Times[0]+ ' 00:00:00'
            this.data2.end_date = this.$route.params.data.Times[1] + ' 23:59:59'
            this.data2.DistributorID = this.$route.params.data.DistributorID
            this.data2.ProductID = this.$route.params.data.ProductID
        }
      }
    },
    methods:{
      douyinReport(){
        if(this.data3.start_time==''){
          this.$message.error('请选择开始时间')
          return false
        }
        if(this.data3.end_time==''){
          this.$message.error('请选择结束时间')
          return false
        }
        const loading = this.$loading({
          lock: true,
          text: '报表下载中，请稍后',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        exportDouyinCodeVerifyRecord(this.data3).then(res=>{
          if(res.data.status=='ok'){
            loading.close();
            window.location.href = res.data.result.url
          }else{
            loading.close();
            this.$message.error(res.data.msg)
          }
        })
      },
      salefour(){
        if(this.data2.start_date==''){
          this.$message.error('请选择开始时间')
          return false
        }
        if(this.data2.end_date==''){
          this.$message.error('请选择结束时间')
          return false
        }
        this.activeCss = '166'
        this.data2.ProductID = this.data2.productid
        const loading = this.$loading({
          lock: true,
          text: '报表下载中，请稍后',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        GetScenicDisSellOneExport(this.data2).then(res=>{
          if(res.data.status=='ok'){
            loading.close();
            window.location.href = res.data.result
          }else{
            loading.close();
            this.$message.error(res.data.msg)
          }
        })
      },
      saleThree(){
        if(this.data3.starttime==''){
          this.$message.error('请选择开始时间')
          return false
        }
        if(this.data3.endtime==''){
          this.$message.error('请选择结束时间')
          return false
        }
        this.activeCss = '233'
        this.data3.date = this.data3.starttime
        this.data3.starttime =  this.data3.starttime 
        this.data3.endtime = this.data3.endtime 
        const loading = this.$loading({
          lock: true,
          text: '报表下载中，请稍后',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        DirectSellingTJXqExport(this.data3).then(res=>{
          if(res.data.status=='ok'){
            loading.close();
            window.location.href = res.data.result
          }else{
            loading.close();
            this.$message.error(res.data.msg)
          }
        })
      },
      changeData2(flag){
        if(flag){
          if(this.data3.end_time){
            if(this.getDate(this.data3.start_time)>this.getDate(this.data3.end_time)){
              this.data3.start_time = ''
              this.$message.error('开始时间不能大于结束时间')
            }
          }
        }else{
          if(this.data3.start_time){
            if(this.getDate(this.data3.start_time)>this.getDate(this.data3.end_time)){
              this.data3.end_time = ''
              this.$message.error('结束时间不能小于开始时间')
            }
          }
        }
      },
      changeData1(flag){
        if(flag){
          if(this.data2.end_date){
            if(this.getDate(this.data2.start_date)>this.getDate(this.data2.end_date)){
              this.data2.start_date = ''
              this.$message.error('开始时间不能大于结束时间')
            }
          }
        }else{
          if(this.data2.start_date){
            if(this.getDate(this.data2.start_date)>this.getDate(this.data2.end_date)){
              this.data2.end_date = ''
              this.$message.error('结束时间不能小于开始时间')
            }
          }
        }
      },
      changeData(flag){
        if(flag){
          if(this.dataOrder.end_time){
            if(this.getDate(this.dataOrder.start_time)>this.getDate(this.dataOrder.end_time)){
              this.dataOrder.start_time = ''
              this.$message.error('开始时间不能大于结束时间')
            }
          }
        }else{
          if(this.dataOrder.start_time){
            if(this.getDate(this.dataOrder.start_time)>this.getDate(this.dataOrder.end_time)){
              this.dataOrder.end_time = ''
              this.$message.error('结束时间不能小于开始时间')
            }
          }
        }
      },
      getDate(m){
        var date = new Date(m);
        var time1 = date.getTime();
        return time1
      },
      tabs(i){
        this.active = i
        this.types = ''
      },
      exportMing(){
        if(this.dataOrder.start_time==''){
          this.$message.error('请选择开始时间')
          return false
        }
        if(this.dataOrder.end_time==''){
          this.$message.error('请选择结束时间')
          return false
        }
        this.activeCss = '3'
        const loading = this.$loading({
          lock: true,
          text: '报表下载中，请稍后',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        VerificationSheetDetailExport(this.dataOrder).then(res=>{
          if(res.data.status=='ok'){
            loading.close();
            window.location.href = res.data.result
          }else{
            loading.close();
            this.$message.error(res.data.msg)
          }
        })
      },
      Verification(){
        if(this.dataOrder.start_time==''){
          this.$message.error('请选择开始时间')
          return false
        }
        if(this.dataOrder.end_time==''){
          this.$message.error('请选择结束时间')
          return false
        }
        this.activeCss = '2'
        const loading = this.$loading({
              lock: true,
              text: '报表下载中，请稍后',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
        VerificationSheetExport(this.dataOrder).then(res=>{
          if(res.data.status=='ok'){
            loading.close();
            window.location.href = res.data.result
          }else{
            loading.close();
            this.$message.error(res.data.msg)
          }
        })
      },
      exportOrder(){
        if(this.dataOrder.start_time==''){
          this.$message.error('请选择开始时间')
          return false
        }
        if(this.dataOrder.end_time==''){
          this.$message.error('请选择结束时间')
          return false
        }
        this.activeCss = '1'
        const loading = this.$loading({
              lock: true,
              text: '报表下载中，请稍后',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
          ScenicPostExport(this.dataOrder).then(res=>{
            if(res.data.status=='ok'){
                loading.close();
                window.location.href = res.data.result
            }else{
              loading.close();
              this.$message.error(res.data.msg)
            }
          })
      },
      ptionTwoDetail(){
        if(this.data2.start_date==''){
          this.$message.error('请选择开始时间')
          return false
        }
        if(this.data2.end_date==''){
          this.$message.error('请选择结束时间')
          return false
        }
        this.activeCss = '155'
        const loading = this.$loading({
                lock: true,
                text: '报表下载中，请稍后',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
        ScenicDisTicketTJXQExport(this.data2).then(res=>{
          if(res.data.status=='ok'){
                loading.close();
              window.location.href = res.data.result
          }else{
            loading.close();
            this.$message.error(res.data.msg)
          }
        })
      },
      ticketTwoDetail(){
        if(this.data2.start_date==''){
          this.$message.error('请选择开始时间')
          return false
        }
        if(this.data2.end_date==''){
          this.$message.error('请选择结束时间')
          return false
        }
        this.activeCss = '144'
        const loading = this.$loading({
                lock: true,
                text: '报表下载中，请稍后',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
        RefundTJXQExport(this.data2).then(res=>{
          if(res.data.status=='ok'){
            
                loading.close();
              window.location.href = res.data.result
          }else{
            loading.close();
            this.$message.error(res.data.msg)
          }
        })
      },
      ticketTwo(i){
        if(this.data2.start_date==''){
          this.$message.error('请选择开始时间')
          return false
        }
        if(this.data2.end_date==''){
          this.$message.error('请选择结束时间')
          return false
        }
        if(this.types==''){
          this.$message.error('请选择展示内容')
          return false
        }
        this.activeCss = '10'

        if(this.types=='2'){
          const loading = this.$loading({
                lock: true,
                text: '报表下载中，请稍后',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
          DisProductRefundExport(this.data2).then(res=>{
            if(res.data.status=='ok'){
                loading.close();
              window.location.href = res.data.result
            }else{
              loading.close();
              this.$message.error(res.data.msg)
            }
          })
        }else{
          const loading = this.$loading({
                lock: true,
                text: '报表下载中，请稍后',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
          DistributorIDRefundDateExport(this.data2).then(res=>{
            if(res.data.status=='ok'){
                loading.close();
              window.location.href = res.data.result
            }else{
              loading.close();
              this.$message.error(res.data.msg)
            }
          })
        }
      },
      ptionTwo(i){
        if(this.data2.start_date==''){
          this.$message.error('请选择开始时间')
          return false
        }
        if(this.data2.end_date==''){
          this.$message.error('请选择结束时间')
          return false
        }
        if(this.types==''){
          this.$message.error('请选择展示内容')
          return false
        }
        this.activeCss = '11'

        if(this.types=='2'){
          const loading = this.$loading({
                lock: true,
                text: '报表下载中，请稍后',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
          DisProductVerifiExport(this.data2).then(res=>{
            if(res.data.status=='ok'){
                loading.close();
              window.location.href = res.data.result
            }
          })
        }else if(this.types=='1'){
          const loading = this.$loading({
            lock: true,
            text: '报表下载中，请稍后',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          ScenicDisTicketTJExport(this.data2).then(res=>{
            if(res.data.status=='ok'){
              loading.close();
              window.location.href = res.data.result
            }else{
              loading.close();
              this.$message.error(res.data.msg)
            }
          })
        }else if(this.types=='3'){
          const loading = this.$loading({
            lock: true,
            text: '报表下载中，请稍后',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          distributorProductTJExport(this.data2).then(res=>{
            if(res.data.status=='ok'){
              loading.close();
              window.location.href = res.data.result
            }else{
              loading.close();
              this.$message.error(res.data.msg)
            }
          })
        }else if(this.types=='4'){
          const loading = this.$loading({
            lock: true,
            text: '报表下载中，请稍后',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          channelCodeProductTJExport(this.data2).then(res=>{
            if(res.data.status=='ok'){
              loading.close();
              window.location.href = res.data.result
            }else{
              loading.close();
              this.$message.error(res.data.msg)
            }
          })
        }
      },
      saleTwo(i){
        if(this.data2.start_date==''){
          this.$message.error('请选择开始时间')
          return false
        }
        if(this.data2.end_date==''){
          this.$message.error('请选择结束时间')
          return false
        }
        if(this.types==''){
          this.$message.error('请选择展示内容')
          return false
        }
        this.activeCss = '12'

        if(this.types=='2'){
          // 产品
          const loading = this.$loading({
                lock: true,
                text: '报表下载中，请稍后',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
          ScenicDisSellOneExport(this.data2).then(res=>{
            if(res.data.status=='ok'){
                loading.close();
              window.location.href = res.data.result
            }else{
              loading.close();
              this.$message.error(res.data.msg)
            }
          })
        }else{
          // 自然日
          const loading = this.$loading({
                lock: true,
                text: '报表下载中，请稍后',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
          exportDistributorSalesStatistics(this.data2).then(res=>{
            if(res.data.status=='ok'){
                loading.close();
              window.location.href = res.data.result
            }else{
              loading.close();
              this.$message.error(res.data.msg)
            }
          })
        }
      },
      // 订单导出
      // orderExport(){
      //   let data = {

      //   }
      //   ScenicPostExport(data).then(res=>{
      //     console.log(res)
      //   })
      // }
      // 直销统计 销售记录
      sale(i){
        if(this.data3.starttime==''){
          this.$message.error('请选择开始日期')
          return false
        }
        if(this.data3.endtime==''){
          this.$message.error('请选择结束日期')
          return false
        }
        if(this.types==''){
          this.$message.error('请选择展示内容')
          return false
        }
        this.activeCss = '20'

        this.data3.starttime =  this.data3.starttime 
        this.data3.endtime = this.data3.endtime 
        if(this.types=='2'){
          const loading = this.$loading({
                lock: true,
                text: '报表下载中，请稍后',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
          ProductIDSalesStatisticsExport(this.data3).then(res=>{
            if(res.data.status=='ok'){
                loading.close();
              window.location.href = res.data.result
            }else{
              loading.close();
              this.$message.error(res.data.msg)
            }
          })
        }else{
          const loading = this.$loading({
                lock: true,
                text: '报表下载中，请稍后',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
          exportSalesStatistics(this.data3).then(res=>{
            if(res.data.status=='ok'){
                loading.close();
              window.location.href = res.data.result
            }else{
              loading.close();
              this.$message.error(res.data.msg)
            }
          })
        }
      },
      // 核销记录
      ption(i){
        if(this.data3.starttime==''){
          this.$message.error('请选择开始日期')
          return false
        }
        if(this.data3.endtime==''){
          this.$message.error('请选择结束日期')
          return false
        }
        if(this.types==''){
          this.$message.error('请选择展示内容')
          return false
        }
        this.activeCss = '21'

        this.data3.starttime =  this.data3.starttime 
        this.data3.endtime = this.data3.endtime 
        if(this.types=='2'){
          const loading = this.$loading({
                lock: true,
                text: '报表下载中，请稍后',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
          ProductTicketConsumeTJExport(this.data3).then(res=>{
            if(res.data.status=='ok'){
                loading.close();
              window.location.href = res.data.result
            }else{
              loading.close();
              this.$message.error(res.data.msg)
            }
          })
        }else{
          const loading = this.$loading({
            lock: true,
            text: '报表下载中，请稍后',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          TicketConsumeTJExport(this.data3).then(res=>{
            if(res.data.status=='ok'){
                loading.close();
              window.location.href = res.data.result
            }else{
              loading.close();
              this.$message.error(res.data.msg)
            }
          })
        }
        
      },
      // 核销记录详情导出
      ptionDeta(){
        if(this.data3.starttime==''){
          this.$message.error('请选择开始时间')
          return false
        }
        if(this.data3.endtime==''){
          this.$message.error('请选择结束时间')
          return false
        }
        this.activeCss = '255'

        this.data3.productid = this.data3.ProductID
        this.data3.date = this.data3.starttime
        this.data3.starttime =  this.data3.starttime 
        this.data3.endtime = this.data3.endtime 
        const loading = this.$loading({
              lock: true,
              text: '报表下载中，请稍后',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
        TicketConsumeExport(this.data3).then(res=>{
          if(res.data.status=='ok'){
              loading.close();
            window.location.href = res.data.result
          }else{
            loading.close();
            this.$message.error(res.data.msg)
          }
        })
      },
      // 退票记录
      ticket(i){
        if(this.data3.starttime==''){
          this.$message.error('请选择开始日期')
          return false
        }
        if(this.data3.endtime==''){
          this.$message.error('请选择结束日期')
          return false
        }
        this.activeCss = '22'
        this.data3.starttime =  this.data3.starttime 
        this.data3.endtime = this.data3.endtime 
        if(this.types=='2'){
          const loading = this.$loading({
                lock: true,
                text: '报表下载中，请稍后',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
          ProductRefundExport(this.data3).then(res=>{
            if(res.data.status=='ok'){
                loading.close();
              window.location.href = res.data.result
            }else{
              loading.close();
              this.$message.error(res.data.msg)
            }
          })
        }else{
          const loading = this.$loading({
                lock: true,
                text: '报表下载中，请稍后',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
          RefundDateExport(this.data3).then(res=>{
            if(res.data.status=='ok'){
                loading.close();
              window.location.href = res.data.result
            }else{
              loading.close();
              this.$message.error(res.data.msg)
            }
          })
        }
      },
      ticketDeta(){
        if(this.data3.starttime==''){
          this.$message.error('请选择开始时间')
          return false
        }
        if(this.data3.endtime==''){
          this.$message.error('请选择结束时间')
          return false
        }
        this.activeCss = '266'
        this.data3.start_date = this.data3.starttime 
        this.data3.end_date = this.data3.endtime 
        const loading = this.$loading({
              lock: true,
              text: '报表下载中，请稍后',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
        RefundExport(this.data3).then(res=>{
          if(res.data.status=='ok'){
              loading.close();
            window.location.href = res.data.result
          }else{
            loading.close();
            this.$message.error(res.data.msg)
          }
        })
      }
    }
  }
</script>
<style lang="less" scoped>
.title{
  display: flex;
  align-items: center;
  >span{
    color: #666;
    font-size: 1.4rem;
  }
  /deep/ .el-breadcrumb__inner{
    color: #000;
  }
}
.tab{
  display: flex;
  margin-top: 1.8rem;
  >div{
    margin-right: 2rem;
    border-radius: 0.4rem;
    width: 39rem;
    height: 15rem;
    background: #fff;
    padding: 2rem ;
    box-sizing: border-box;
    cursor: pointer;
    >span{
      color: #666;
      font-size: 14px;
    }
    >div{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 2rem;
      span{
        color: #246DEB;
        font-size: 2rem;
      }
      img{
        width: 7.6rem;
        height: 7.1rem;
      }
    }
  }
  .switDiv{
    background: #246DEB;
    span{
      color: #fff;
    }
  }
}
.center{
  padding: 0 2rem;
  box-sizing: border-box;
  margin-top: 2.3rem;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 60rem;
}
.orders{
  display: flex;
  align-items: center;
  >div{
    display: flex;
    flex-direction: column;
    &:last-child{
      margin-left: 2rem;
    }
    &:first-child{
      margin-right: 2rem;
    }
    >span{
      margin-bottom: 0.9rem;
    }
  }
  span{
    font-size: 1.4rem;
  }
  
}
.select{
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
  span{
    margin-bottom: 0.9rem;
    font-size: 1.4rem;
  }
}
.select_bot{
  display: flex;
  align-items: center;
  >div{
    &:nth-child(1){
      margin-right: 2rem;
    }
  }
}
/deep/.el-input{
    width: 28rem;
  }
  /deep/.el-date-editor{
    width: 28rem;
  }
  /deep/.el-select{
    width: 28rem;
  }
  .ative_btns{
    margin-top: 10rem;
    >div{
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      div{
        cursor: pointer;
        padding: 1.1rem 3.2rem;
        box-sizing: border-box;
        background:  #246DEB;
        border-radius: 0.4rem;
        margin-right: 2rem;
        color: #fff;
        font-size: 1.4rem;
        margin-bottom: 1.5rem;
      }
    }
  }
  .Selected{
    background: red !important;
  }
</style>